<template>
  <div id="app">
    <div class="container">
      <Navbar/>
    </div>
    <hr class="hr"/>
    <br/>
    <div class="main-container">
      <router-view/>
    </div>
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue'

export default {
  name: 'app',
  components: {
    Navbar,
  },
}
</script>

<style scoped>
.hr {
  background-color: #E6CE9E;
  margin: 0;
  height: 5px;
}
.centered {
  margin-top: 20px;
  text-align: center;
}
</style>
